import { motion } from 'framer-motion'
import styled from 'styled-components'
import { AI_HELP_RESERVED_SPACE_CSS_VAR } from '@constants/layout'

export const ModalDialog = styled(motion.div).attrs({
  variants: {
    init: { scale: 1.1, y: 0 },
    show: { scale: 1, y: 0 },
    exit: { scale: 0.95, y: 0 }
  },
  initial: 'init',
  animate: 'show',
  exit: 'exit'
})<{ width: number; height: number }>`
  width: 100dvw;
  height: 100dvh;
  z-index: 50;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  width: ${({ width }) => width || 375}px;
  max-width: calc(100dvw - var(${AI_HELP_RESERVED_SPACE_CSS_VAR}, 0px));
  max-height: ${({ height }) => height || 735}px;
  box-shadow: 0px 8px 22px rgba(27, 31, 35, 0.07);
  overflow: hidden;

  & > div {
    border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  }
  @media only screen and (max-width: 376px) {
    max-height: 100dvh;
  }
`

export const ModalOverlay = styled(motion.div).attrs({
  variants: {
    initial: { opacity: 0 },
    isOpen: { opacity: 1 },
    exit: { opacity: 0, transition: { duration: 0.2 } }
  },
  initial: 'initial',
  animate: 'isOpen',
  exit: 'exit'
})`
  position: fixed;
  top: 0;
  left: 0;
  right: var(${AI_HELP_RESERVED_SPACE_CSS_VAR}, 0px);
  bottom: 0;
  z-index: 9000;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.backdrop};
  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (min-width: 376px) {
    overflow: hidden;
  }
`
